import { CONV_STORAGE, Video, kinoParticipants, volumeManager } from "../../../libs/roomnew"
import { updateVideoQuality } from "../video-quality/actions"
import { SPACE_CHANGED } from "./constants"
import { handleSpaceMenuUpdate, volumeHandleLocalParticipantSpaceChange, volumeHandleRemoteParticipantSpaceChange } from "./handlers"

// A space change moves participant tiles between the main grid, the spaces
// panel and the lobby. The DOM/layout for those tiles is not fully settled
// synchronously, so reading element positions immediately can compute a
// just-revisible tile as "not visible" and leave its stream suspended on the
// bridge. We recompute viewport visibility once more after the layout settles
// and force a receiver-constraint update so any source that should now be
// forwarded is re-requested.
const SPACE_CHANGE_SETTLE_DELAY=600;

export const addSpacesEventHandlers=()=>{
    window.addEventListener(SPACE_CHANGED,({detail:data})=>{
        console.log(`%c[EVENT]%c - SPACE_CHANGED`,'color:green','color:unset',data)
        onSpaceChanged(data)
    })
}

const onSpaceChanged=(data)=>{
    const participant = kinoParticipants.get(data.pid);
    if(!participant){return}
    const space = data.newSpace ? CONV_STORAGE.getSpace(data.newSpace) : null;
    const oldSpace = data.oldSpace ? CONV_STORAGE.getSpace(data.oldSpace) : null;
    Video.efss.inViewPortConversations(false);
    if(participant.local)
    onLocalParticipantSpaceChanged(space,oldSpace)
    else
    onRemoteParticipantSpaceChanged(participant,space,oldSpace)
    handleSpaceMenuUpdate(space, oldSpace)
    // Recompute visibility after the tiles have finished moving so streams that
    // are now in view (but were suspended) get re-requested from the bridge.
    setTimeout(()=>{
        try {
            Video.efss.inViewPortConversations(false);
            updateVideoQuality(false,true);
        } catch (error) {
            console.error("[Kino Error] [spaces events] settle re-request failed",error)
        }
    }, SPACE_CHANGE_SETTLE_DELAY);
}

const onLocalParticipantSpaceChanged=(space,oldSpace=null)=>{
    volumeHandleLocalParticipantSpaceChange(space,oldSpace)
    volumeManager.stateChangedWhileMuted=true;
    // if(Video.lockMasterVolume.isLocked()){
    //     Video.lockMasterVolume.updateIndividualVolumeSlider();
    // }
}

const onRemoteParticipantSpaceChanged=(participant,space,oldSpace=null)=>{
    volumeHandleRemoteParticipantSpaceChange(participant,space,oldSpace)
    // handleSpaceMenuUpdate(space, oldSpace)
}
